import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "screener-options" }
const _hoisted_2 = { class: "screener-option" }

import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UniversalScreenersModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ['update:visible'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();
const visible = ref(props.visible);
const isLoading = ref(false);

watch(
  () => props.visible,
  (val) => {
    visible.value = val;
  },
);

watch(visible, (val) => {
  emit('update:visible', val);
});

const selectScreener = (screenerType: string, view = 'portal') => {
  if (screenerType === 'ssis_colab') {
    isLoading.value = true;
    router.push({
      name: 'UniversalScreener',
      params: { type: 'ssis-colab' },
      query: { view },
    });
    visible.value = false;
    isLoading.value = false;
  }
};

const closeModal = () => {
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: "Select Screener",
    closable: true,
    draggable: false,
    style: { width: '450px' },
    class: "universal-screeners-modal"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        label: "Cancel",
        class: "p-button-text",
        onClick: closeModal
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Button), {
            label: "SSIS CoLab",
            class: "p-button-outlined w-full",
            loading: isLoading.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectScreener('ssis_colab')))
          }, null, 8, ["loading"]),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-color-secondary mt-2" }, "Access SSIS CoLab screeners and assessments", -1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})